import {serviceService} from '../../_services'

export default {
  state: {
    services: [],
    maxServices: 50
  },
  mutations: {
    setServices (state, payload) {
      state.services = payload
    },
    setEditedService (state, payload) {
      var foundIndex = state.services.findIndex(service => service.id === payload.id)
      state.services.splice(foundIndex, 1, payload)
    },
    addService (state, payload) {
      if (state.services.length === state.maxServices) {
        state.services.push(payload)
        state.maxServices += 1
      }
    },
    addServices (state, payload) {
      if (state.services.length <= (state.maxServices - payload.length)) {
        state.services = state.services.concat(payload)
      }
    },
    removeService (state, payload) {
      var foundIndex = state.services.findIndex(service => service.id === payload)
      if (foundIndex > -1) {
        state.services.splice(foundIndex, 1)
        state.maxServices -= 1
      }
    },
    setMaxServices (state, payload) {
      state.maxServices = payload
    }
  },
  actions: {
    loadServices ({dispatch, commit}, filter) {
      dispatch('startDataLoading')
      serviceService.searchServices(filter.searchTerms, filter.page, filter.size)
        .then(response => {
          commit('setMaxServices', response.data.totalElements)

          const mappedServices = response.data.content.map(service => ({
            id: service.id,
            name: service.name,
            privateHourFee: service.privateHourFee,
            businessHourFee: service.businessHourFee
          }))

          commit('addServices', mappedServices)
        })
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopDataLoading'))
    },
    resetServices ({commit}) {
      commit('setServices', [])
      commit('setMaxServices', 50)
    },
    addService ({dispatch, commit}, service) {
      dispatch('startLoading')
      serviceService.createService(service)
        .then(response => {
          commit('addService', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich angelegt.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    editService ({dispatch, commit}, service) {
      dispatch('startLoading')
      serviceService.updateService(service)
        .then(response => {
          commit('editService', response.data)
        })
        .then(() => dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich geändert.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    },
    deleteService ({dispatch, commit}, serviceId) {
      dispatch('startLoading')
      serviceService.deleteService(serviceId)
        .then(response => {
          commit('removeService', serviceId)
        })
        .then(() => dispatch('showNotification', {
          title: 'Dienstleistung erfolgreich gelöscht.',
          type: 'primary'
        }))
        .catch(error => dispatch('handleError', error))
        .finally(() => dispatch('stopLoading'))
    }
  },
  getters: {
    services (state) {
      return state.services
    },
    maxServices (state) {
      return state.maxServices
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/service/index.js